import { instance as getApi } from '@/helpers/api.js'
import { getI18n } from './i18n'

/** only used when localStorage is not available */
let noStorageCsrfToken: string | null = null

/**
 * Stores the CSRF token in the browser's localStorage
 * for further use during the session.
 *
 * This is needed to support multiple browser windows.
 *
 * @param {String} token
 */
export function storeCsrfToken(token: string) {
    if (Storage) {
        localStorage.setItem('ebau.csrfToken', token)
    } else {
        noStorageCsrfToken = token
    }
}

/**
 * Retrieves the csrf token from the browser's
 * local storage
 */
export function getCsrfToken() {
    if (Storage) {
        return localStorage.getItem('ebau.csrfToken') ?? ''
    } else {
        return noStorageCsrfToken ?? ''
    }
}

type LoginResponse = {
    user: any
    redirectUrl: string
}

export async function login(username: string, password: string): Promise<LoginResponse> {
    try {
        const response = await getApi().post('/auth/login', {
            email: username,
            password: password,
        })
        if (response.data.benutzer) {
            let redirectUrl = '/'
            const split = window.location.href.split('?redirect=')
            if (split.length === 2) {
                redirectUrl = decodeURIComponent(split[1].replace(/#.*/, ''))
            }
            return { user: response.data.benutzer, redirectUrl: redirectUrl }
        } else {
            throw new Error(getI18n().t('denied_wrong_login'))
        }
    } catch (e: any) {
        if (e?.response?.data?.error?.msg) {
            throw new Error(getI18n().t(e.response.data.error.msg))
        }
        throw new Error(getI18n().t('denied_wrong_login'))
    }
}

export async function resetPassword(username: string) {
    try {
        await getApi().post('/auth/reset', {
            email: username,
        })
    } catch (e) {
        throw new Error('Hoppla, da ist was schief gelaufen...')
    }
}

export async function logout() {
    await getApi().get('/auth/logout')
    window.location.reload()
}

export async function verifyUser(password: string) {
    try {
        const response = await getApi().post('/auth/verifyUser', {
            password: password,
        })
        return response.data.verified
    } catch (e) {
        throw new Error('Hoppla, da ist was schief gelaufen...')
    }
}

export default {
    login,
    logout,
    resetPassword,
    verifyUser,
}
